// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".level2-menu.admininstration-menu{background-color:#EFF6FF}.level2-menu.admininstration-menu .level2-menu-title{text-align:center}\n", ""]);
// Exports
module.exports = exports;
